module.exports = {
    familyData: () => {
        return [
            {
                "CAMIONETAS" : [
                    {
                        "Nombre":"ESCAPE",
                        "Imagen":require("./../UI/canvas/sidebar/familias/Escape.webp")
                    },
                    {
                        "Nombre":"BRONCO SPORT",
                        "Imagen":require("./../UI/canvas/sidebar/familias/Bronco.webp")
                    },
                    {
                        "Nombre":"EDGE",
                        "Imagen":require("./../UI/canvas/sidebar/familias/Edge.webp")
                    },
                    {
                        "Nombre":"EXPLORER",
                        "Imagen":require("./../UI/canvas/sidebar/familias/Explorer.webp")
                    },
                    {
                        "Nombre":"EXPEDITION",
                        "Imagen":require("./../UI/canvas/sidebar/familias/Expedition.webp")
                    }
                ],
                "AUTOMÓVILES" : [
                    {
                        "Nombre":"MUSTANG",
                        "Imagen":require("./../UI/canvas/sidebar/familias/Mustang.webp")
                    }
                ],
                "PICK-UPS" : [
                    {
                        "Nombre":"RANGER",
                        "Imagen":require("./../UI/canvas/sidebar/familias/Ranger.webp")
                    },
                    {
                        "Nombre":"F-150",
                        "Imagen":require("./../UI/canvas/sidebar/familias/F-150.webp")
                    },
                    {
                        "Nombre":"RANGER RAPTOR",
                        "Imagen":require("./../UI/canvas/sidebar/carros/Ranger Raptor.webp")
                    },
                    {
                        "Nombre":"F-150 RAPTOR",
                        "Imagen":require("./../UI/canvas/sidebar/carros/F-150 Raptor.webp")
                    }
                ],
                "PERFORMANCE" : [
                    {
                        "Nombre":"MUSTANG MACH 1",
                        "Imagen":require("./../UI/canvas/sidebar/carros/Mustang Mach 1.webp")
                    },
                    {
                        "Nombre":"EDGE ST",
                        "Imagen":require("./../UI/canvas/sidebar/carros/Edge ST.webp")
                    },
                    {
                        "Nombre":"EXPLORER ST",
                        "Imagen":require("./../UI/canvas/sidebar/carros/Explorer ST.webp")
                    },
                    {
                        "Nombre":"RANGER RAPTOR",
                        "Imagen":require("./../UI/canvas/sidebar/carros/Ranger Raptor.webp")
                    },
                    {
                        "Nombre":"F-150 RAPTOR",
                        "Imagen":require("./../UI/canvas/sidebar/carros/F-150 Raptor.webp")
                    }
                ],
                "HÍBRIDOS" : [
                    {
                        "Nombre":"ESCAPE TITANIUM 4X4 FHEV",
                        "Imagen":require("./../UI/canvas/sidebar/carros/Escape Hibrida.webp")
                    },
                    {
                        "Nombre":"ESCAPE SE 4X2 FHEV",
                        "Imagen":require("./../UI/canvas/sidebar/carros/Escape SE 4x2 HEV.webp")
                    },
                    {
                        "Nombre":"ESCAPE SEL 4X2 FHEV",
                        "Imagen":require("./../UI/canvas/sidebar/carros/Escape SEL 4x2 HEV.webp")
                    },
                    {
						Nombre: 'F-150 PLATINUM FHEV',
						Imagen: require('./../UI/canvas/sidebar/carros/F-150PlatinumFHEV.webp'),
					},
                    {
						Nombre: 'F-150 XLT FHEV',
						Imagen: require('./../UI/canvas/sidebar/carros/F-150 XLT.webp'),
					},
                ]
            }
        ]
    }
}